import { default as PrivateImage } from '../../../shared/PrivateImage';
import React from 'react';
import baseUrl from '../../../../BaseURL';
import './MemberIdentityCard.css';
import { getMembershipReference } from './membershipNumber';

export function formatCardDate(value) {
  if (!value) return '—';
  const match = String(value).match(/^(\d{4})-(\d{2})-(\d{2})(?:T.*)?$/);
  if (!match) return String(value);
  const date = new Date(`${match[1]}-${match[2]}-${match[3]}T00:00:00Z`);
  if (Number.isNaN(date.getTime()) || date.toISOString().slice(0, 10) !== `${match[1]}-${match[2]}-${match[3]}`) return String(value);
  return date.toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric', timeZone: 'UTC' });
}

function Detail({ label, value }) {
  return <div className="fin-id-detail"><dt>{label}</dt><dd>{value === null || value === undefined || value === '' ? '—' : value}</dd></div>;
}

/** Shared screen and print face. All identity values come from the existing member record. */
export default function MemberIdentityCard({ data = {}, stateOfIssue, dateOfIssu, dateOfExpiry, ID_ref_Num, back = false }) {
  const name = [data.fname, data.lname].filter(Boolean).join(' ') || 'Member name';
  const dense = name.length > 30 || [data.position, data.department, data.stateoforigin, data.lga].some(value => String(value || '').length > 24);
  const reference = ID_ref_Num || getMembershipReference(data);
  const membershipNumber = reference ? `FIN/${reference}` : 'Not assigned';

  if (back) return <div className="fin-id-frame"><article className="fin-identity-card fin-id-back" aria-label="Membership ID card back">
    <header className="fin-id-back-heading">FITYANUL ISLAM OF NIGERIA<span>MEMBERSHIP IDENTITY CARD</span></header>
    <div className="fin-id-back-body"><div className="fin-id-watermark" aria-hidden="true"><img src="/assets/fit.jpeg" alt="" /></div><div className="fin-id-back-notice"><h2>OWNERSHIP &amp; RETURN</h2><p>This card is the property of Fityanul Islam of Nigeria and is for the named member’s use only.</p><p>If found, please hand it to any Fityanul Islam office or member, or the nearest police station.</p></div></div>
    <footer className="fin-id-back-footer">FITYANUL ISLAM · RC: 8847</footer>
  </article></div>;

  return (
    <div className="fin-id-frame">
      <article className={`fin-identity-card${dense ? ' fin-id-dense' : ''}`} aria-label={`Membership card for ${name}`}>
        <header className="fin-id-brand">
          <div className="fin-id-emblem"><img src="/assets/fit.jpeg" alt="Fityanul Islam emblem" width="56" height="56" /></div>
          <div className="fin-id-organisation"><p className="fin-id-arabic" lang="ar" dir="rtl">فتيان الإسلام في جمهورية نيجيريا</p><p className="fin-id-english">FITYANUL ISLAM</p><span className="fin-id-country">OF NIGERIA</span></div>
          <div className="fin-id-national-mark"><img src="/assets/nigeria-coat-of-arms.svg" alt="Coat of arms of Nigeria" width="58" height="48" /><strong>RC: 8847</strong></div>
        </header>
        <div className="fin-id-body">
          <div className="fin-id-watermark" aria-hidden="true"><img src="/assets/fit.jpeg" alt="" width="180" height="180" draggable={false} /></div>
          <div className="fin-id-portrait-column">
            <div className="fin-id-photo">
              {data.picture ? <PrivateImage src={`${baseUrl}/files/assets/MemberPictures/${data.picture}`} alt={`Portrait of ${name}`} /> : <span className="fin-id-photo-placeholder">PHOTO</span>}
            </div>
            <p className="fin-id-portrait-caption">MEMBERSHIP IDENTITY CARD</p>
          </div>
          <div className="fin-id-information">
            <div className="fin-id-name-block"><p>MEMBER NAME</p><h2 className={name.length > 30 ? 'fin-id-long-name' : ''}>{name}</h2></div>
            <dl className="fin-id-details">
              <Detail label="Department" value={data.department} />
              <Detail label="Position" value={data.position} />
              <Detail label="Gender" value={data.gender} />
              <Detail label="Age" value={data.age} />
              <Detail label="State of origin" value={data.stateoforigin} />
              <Detail label="Local government" value={data.lga} />
            </dl>
          </div>
        </div>
        <footer className="fin-id-footer">
          <div className="fin-id-number"><span>MEMBERSHIP NUMBER</span><strong>{membershipNumber}</strong></div>
          <dl className="fin-id-validity"><Detail label="State of issue" value={stateOfIssue} /><Detail label="Date of issue" value={formatCardDate(dateOfIssu)} /><Detail label="Expiry date" value={formatCardDate(dateOfExpiry)} /></dl>
        </footer>
      </article>
    </div>
  );
}
